export default "__VITE_ASSET__c7631683__"